export const SignUp = {
  "NewIntroduce": "Make document edits on any device through any web browser.",
  "PBUContent": "Easily edit, merge, and convert PDF files in any browser.",
  "EBUContent1": "Enable PDF Editing for <em>Campus-wide</em> Remote Access. ",
  "EBUContent2": "Discover Complete PDF Solutions for <em>Teachers</em>, Students, and School IT across all devices. ",
  "HeaderDesc": "Sign Up",
  "CarsiDesc": "<span class=\"font-italic\">Free</span> for CARSI and CSTCloudFed users",
  "NotValidEmail": "This is not a valid email address.",
  "EmailRequired": "Please input your email address.",
  "PasswordRequired": "Please input a password.",
  "YourNameRequired": "Please input your name.",
  "NotValidPhone": "This is not a valid phone number.",
  "PhoneRequired": "Please input your phone number.",
  "AlreadyHasAccount": "Already have an account?",
  "SignIn": "Sign In",
  "SignUpNow": "Sign Up Now",
  "OrSignWith": "OR SIGN IN WITH FOLLOWING ACCOUNT",
  "PasswordMinimumLength": "Password must be at least 6 characters.",
  "password_length_limit": "Password must have 8-16 characters.",
  "password_mix": "At least two types of letters, numbers, and symbols are required.",
  "EmailPlaceHolder": "Email",
  "PasswordPlaceHolder": "Password",
  "YourNamePlaceHolder": "Name",
  "PhonePlaceHolder": "Phone",
  "EmailExist": "The email address you entered is already registered in our system.",
  "PlatformError": "Platform Error",
  "PolicyIntroduce": "By signing up, you agree to our <span class=\"privacy-policy\">Privacy Policy</span> and <span class=\"terms-service\">Terms of Service</span>.",
  "PrivacyPolicy": "Privacy Policy",
  "And": "and ",
  "TermsOfService": "Terms of Service",
  "End": ".",
  "SignUpTitle": "Sign Up",
  "SignUpSuccess": "Sign Up Successful",
  "SignUpSuccessContent": "The verification email has been sent to your mailbox successfully, please click the link to activate your account. If you do not receive the verification email, please check the spam or bulk mail folder.",
  "CreateOrganizationSubscription": "Create Organization Subscription",
  "HeaderTitle": "Foxit PDF Editor",
  "WorkOnPDF": "<span class=\"font-bold\">Work on PDF Documents in Your Browser</span>",
  "CreatAccount": "<span class=\"font-bold\">Create an Account Now</span>",
  "MoreInfo": "<div>More PDF Products and Apps on</div><div><a class=\"text-purple\" href=\"https://www.foxit.com\" target=\"_blank\">www.foxit.com</a></div>",
  "Edit": "Edit or Add Text and Objects",
  "Comment": "Make Comments and Share PDFs",
  "Organize": "Organize, Insert, and Delete Pages",
  "Convert": "Convert To and From Office and Other Formats",
  "Watermark": "Customize with Header, Footers, and Watermarks",
  "Protect": "Redact, Password Protect, and Sign PDFs",
  "Google": "Google",
  "Facebook": "Facebook",
  "Microsoft": "Microsoft",
  "LinkedIn": "LinkedIn",
  "EduGain": "Institution Login",
  "GakuNin": "GakuNin",
  "RequestsLimit": "Too many requests received, please try again later.",
  "FirstName": "First Name",
  "LastName": "Last Name",
  "RequiredName": "{name} is required.",
  "credentialsExpired": "Your credentials have expired, current session will be signed out.",
  "credentialsExpiredModify": "Your credentials have expired, current session will be signed out. Do you want to save changes to \"{name}\" before leaving?"
}